import { IBaseEntityType, FilterModel } from '@shared/types';
import { FilterOptionType } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/filter.type';
import { ColumnFilterModel } from '@geniuspos/ui-shared/modules/xdm-shared-components/definitions/types/index';

export interface IComposeFilterModel {
  composeFilterModel(text: string): FilterModel;
}

export interface IVisibleEntitiesStructure {
  visibleEntities: IBaseEntityType[];
  total: number;
}

export interface IFilterGroup {
  or?: FilterModel | FilterModelGroup;
  and?: FilterModel | FilterModelGroup;
}

export type FilterModelGroup = FilterModel & IFilterGroup;

export enum FILTER_OPERATORS {
  OR = 'or',
  AND = 'and',
}

export interface IQuickFilterFieldSettings {
  filedName: string;
  type?: FilterOptionType;
  filterType?: string;
}

export interface IColumnFilterWithType extends ColumnFilterModel {
  filterType?: string;
}
